/*
 * Copyright (C) 2014 Spanning Cloud Apps.  All rights reserved.
 */
/**
 * Interceptor module for verifying that any response is not
 * a refresh token error.
 */
'use strict';

angular
  .module('interceptor.token', [])
  /**
   * A factory that registers the token interceptor logic.
   */
  .factory('tokenInterceptor', function ($q, $rootScope, $filter, HTTP_ERROR_STATUS, ALERT_EVENTS) {
    /**
     * Emits a refresh token error
     *
     * @param {*} rejection
     * @returns {*} - The rejection
     */
    function showRefreshTokenError(rejection) {
      $rootScope.$emit(ALERT_EVENTS.ERROR.eventName, $filter('i18n')('INVALID_REFRESH_TOKEN_ERROR'));
      // return a promise resolving value so that any states that depend on
      // the service coming back are satisfied.  Note that http request will be resolve with error
      // so it can be handled the then clause.
      return rejection;
    }
    return {
      // On response failure
      responseError: function (rejection) {
        // With JWT bearer auth there is no refresh token to re-establish via the browser, so surface the error
        // instead of redirecting to re-authorize.
        if (
          rejection.status === HTTP_ERROR_STATUS.REFRESH_TOKEN_BACKUP_USER ||
          rejection.status === HTTP_ERROR_STATUS.REFRESH_TOKEN_NON_BACKUP_USER
        ) {
          return showRefreshTokenError(rejection);
        } else {
          // Return the promise rejection for other errors.
          return $q.reject(rejection);
        }
      }
    };
  });
